module.exports = __webpack_public_path__ + "static/things2-7f62b9d2e3bb2e8c0e779e94a8c3a1d1.png";